import React, { useEffect } from "react";
import "./BecomeAPartner.css";
import { useNavigate } from "react-router-dom";

const BecomeAPartner = () => {
  const navigate = useNavigate();

  const features = [
    { icon: "bi-shield-check", title: "Secure Workflows" },
    { icon: "bi-diagram-3", title: "End-to-End CLM" },
    { icon: "bi-cloud-check", title: "Cloud-Native" },
    { icon: "bi-graph-up-arrow", title: "Analytics & Insights" },
    { icon: "bi-people", title: "Collaboration" },
    { icon: "bi-globe2", title: "Global Compliance" }
  ];

  const items = [
    {
      icon: "bi-graph-up-arrow",
      title: "Tap into soaring CLM demand",
      desc: "Become the trusted partner guiding businesses into modern contracting."
    },
    {
      icon: "bi-diagram-3",
      title: "Offer true end-to-end CLM",
      desc: "Deliver a unified platform that streamlines every stage of the contract lifecycle."
    },
    {
      icon: "bi-cash-coin",
      title: "Scale your revenue smartly",
      desc: "Grow with high-margin implementation, consulting, and managed services."
    },
    {
      icon: "bi-star",
      title: "Differentiate your portfolio",
      desc: "Stand out with a specialized CLM practice and stronger competitive edge."
    },
    {
      icon: "bi-people",
      title: "Close more deals together",
      desc: "Boost sales with joint enablement, GTM alignment, and shared marketing support."
    },
    {
      icon: "bi-globe2",
      title: "Serve clients worldwide",
      desc: "Support global organizations with an enterprise-ready, compliant CLM platform."
    }
  ];

  const benefits = [
    "Attractive, scalable commission models.",
    "Robust go-to-market and partner enablement assets.",
    "Early access to new features and product updates.",
    "Comprehensive product and sales training programs.",
    "Priority support for partners and active deals.",
    "A dedicated Partner Success Manager to help you grow."
  ];

  const steps = [
    { title: "Submit your partnership application form", desc: "Complete the simple application form to express your interest in becoming a partner." },
    { title: "Get connected with a Docusafe Partner Expert", desc: "Our team will review your application and connect with you to discuss the opportunity." },
    { title: "Sign the Partnership Agreement", desc: "Once approved, formalize the partnership by signing the agreement." },
    { title: "Complete the Partner Onboarding course", desc: "Set up your partner portal and complete the onboarding training." },
    { title: "Boast about your Docusafe Partnership", desc: "Promote your partnership on your website and go to market successfully." }
  ];

  useEffect(() => {
    const nodes = document.querySelectorAll(".ht-step");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ht-in-view");
          }
        });
      },
      { threshold: 0.4 }
    );

    nodes.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleBecomePartner = () => {
    navigate("/partner-signup")
  };


  return (
    <div className="guest-container">
      {/* HERO */}
      <section className="zcp-hero px-3 px-md-4 px-lg-5 py-5">
        <div className="row align-items-center g-5">
          {/* Left column - text */}
          <div className="col-lg-6">

            <h1 className="zcp-title">
              Docusafe Contract
              <span className="zcp-gradient"> for Partners</span>
            </h1>

            <p className="zcp-sub">
              Empower your clients to simplify and modernize contract management.
              The CLM market is growing fast, and the opportunity is still wide open.
            </p>

            <div className="zcp-cta-wrap">
              <button
                className="btn zcp-btn-primary"
                type="button"
                onClick={handleBecomePartner}
              >
                Become a Partner
              </button>
              <button
                className="btn zcp-btn-ghost"
                type="button"
              // onClick={handleFindPartner}
              >
                Find a Partner
              </button>
            </div>
          </div>

          {/* Right column - glass card */}
          <div className="col-lg-6">
            <div className="zcp-hero-card zcp-glass-card">
              <div className="zcp-hero-blob zcp-hero-blob--one" />
              <div className="zcp-hero-blob zcp-hero-blob--two" />
              <div className="zcp-hero-graphic">
                <div className="zcp-graphic-header">
                  <span className="zcp-graphic-dot" />
                  <span className="zcp-graphic-dot" />
                  <span className="zcp-graphic-dot" />
                </div>
                <div className="zcp-graphic-body">
                  <div className="zcp-graphic-line zcp-graphic-line--primary" />
                  <div className="zcp-graphic-line" />
                  <div className="zcp-graphic-line" />
                  <div className="zcp-graphic-chip">CLM</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="about-neon  py-5">
        <div className="about-neon-inner container">
          <h2 className="about-neon-title">About Docusafe</h2>

          <p className="about-neon-sub">
            A single, powerful CLM to handle everything from authoring to
            post-execution—without the chaos.
          </p>

          <div className="row justify-content-center g-4 about-neon-grid">
            {features.map((item, index) => (
              <div className="col-6 col-md-4 col-lg-3" key={index}>
                <div className="neon-card">
                  <div className="neon-ring">
                    <div className="neon-circle">
                      <i className={`bi ${item.icon}`}></i>
                    </div>
                  </div>
                  <p className="neon-card-title">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY PARTNER */}
      <section className="why-wrapper py-5">
        <div className=" text-center">
          <h2 className="why-title">
            Why partner with
            <br />
            <span className="why-gradient">Docusafe Contracts?</span>
          </h2>

          <p className="why-sub w-100 w-md-75 mx-auto">
            A rapidly expanding CLM market creates massive opportunity.
            Become the expert who delivers a seamless, end-to-end contracting experience.
          </p>

          <div className="row justify-content-center g-4 why-grid mt-4">
            {items.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="why-tile">
                  <div className="why-tile-icon">
                    <span className="why-tile-circle">
                      <i className={`bi ${item.icon}`}></i>
                    </span>
                  </div>
                  <h5 className="why-tile-title">{item.title}</h5>
                  <p className="why-tile-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHO CAN PARTNER */}
      {/* <section className="who-section py-5">
        <div className="container text-center">
          <h2 className="becom-section-title">
            Who can become a Docusafe Contracts partner?
          </h2>
          <p className="section-sub w-100 w-md-75 mx-auto">
            Tech providers, legal pros, consultants, entrepreneurs—anyone
            helping businesses that handle 10+ contracts a month.
          </p>
        </div>
      </section> */}

      {/* WHAT Docusafe OFFERS */}
      <section className="offer-section  py-5">
        <div className="row align-items-center g-4">
          {/* Left column */}
          <div className="col-lg-5">
            <h2 className="offer-title">What Docusafe brings to the table</h2>
            <p className="offer-sub">
              Unlock new revenue streams with recurring commissions and high-value
              service opportunities.
            </p>
          </div>

          {/* Right column */}
          <div className="col-lg-7">
            <div className="offer-card">
              <ul className="offer-list">
                {benefits.map((item, i) => (
                  <li className="offer-item" key={i}>
                    <span className="offer-bullet">
                      <span className="offer-check">✓</span>
                    </span>
                    <span className="offer-text">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* HOW TO BECOME */}
      <section className="ht-section p-5">
        <div>
          <h2 className="ht-title text-center mb-2">
            How to become a Docusafe Partner
          </h2>
          <p className="ht-subtitle text-center mb-5">
            It’s a simple five-step process to join the Docusafe partner network.
          </p>

          <div className="ht-track">
            <div className="ht-line" />
            {steps.map((step, idx) => (
              <div className="ht-step" key={idx}>
                <div className="ht-number-wrapper">
                  <span className="ht-number">{idx + 1}</span>
                </div>

                <div className="ht-card">
                  <div className="ht-card-icon">
                    {idx === 0 && <i className="bi bi-file-earmark-text-fill"></i>}
                    {idx === 1 && <i className="bi bi-people-fill"></i>}
                    {idx === 2 && <i className="bi bi-pencil-square"></i>}
                    {idx === 3 && <i className="bi bi-mortarboard-fill"></i>}
                    {idx === 4 && <i className="bi bi-megaphone-fill"></i>}
                  </div>

                  <div>
                    <h3 className="ht-card-title">{step.title}</h3>
                    <p className="ht-card-text">{step.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>


      {/* SUBMIT APPLICATION */}
      <section className="submit-section  py-5">
        <h2 className="becom-section-title text-center">
          Submitting your application
        </h2>

        <div className="row align-items-center g-4 mt-4">
          <div className="col-md-8 mx-auto">
            <div className="submit-card glass-card">
              <ul className="submit-list">
                <li>
                  <span>Fill your details</span>
                  <p>Share your contact and business profile.</p>
                </li>
                <li>
                  <span>Pick your strengths</span>
                  <p>Highlight “Legal” and “CLM” expertise.</p>
                </li>
                <li>
                  <span>Choose a partner track</span>
                  <p>Submit, sync with our team, and go live.</p>
                </li>
              </ul>
            </div>
          </div>

          {/* Right column – glass screenshot card */}
          {/* <div className="col-md-6 text-center">
            <div className="hero-card glass-card">
              <img
                src="/mnt/data/b8c23569-64f4-4f66-9f68-97bbb35661f7.png"
                className="img-fluid hero-image"
                alt="Application Screenshot"
              />
            </div>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default BecomeAPartner;
